const TitleDisplay = {
    English: "english",
    Original: "original",
    Romanized: "romanized"
}

export default TitleDisplay;
